
<div class="mb-2" v-html="image"></div>
